import { render, staticRenderFns } from "./AccountDataEdit.vue?vue&type=template&id=5fd6d1ab&scoped=true&"
import script from "./AccountDataEdit.vue?vue&type=script&lang=js&"
export * from "./AccountDataEdit.vue?vue&type=script&lang=js&"
import style0 from "./AccountDataEdit.vue?vue&type=style&index=0&id=5fd6d1ab&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fd6d1ab",
  null
  
)

export default component.exports